/* eslint-disable react-hooks/exhaustive-deps */
import { Col, Form, Row } from "react-bootstrap";
import CardC from "../../components/CustomCard/CardC";
import { Breadcrumb, Loader, Tooltip, Tree, Whisper, toaster } from "rsuite";
import FolderFillIcon from "@rsuite/icons/FolderFill";
import { useEffect, useState } from "react";
import Datatable from "../../components/Datatable/Datatable";
import { sortObjects } from "../../libs/formats";
import peticionBack from "../../libs/peticiones/peticionBack";
import { useStore } from "../../context/AppContext";
import { Folder } from "../../types/filemanager/Folder";
import { swalAction } from "../../components/Modals/ModalConfirm";
import FormName from "./forms/FormName";
import UploadFile from "./forms/uploadFile/UploadFile";
import { Archivo } from "../../types/filemanager/Archivo";
import ModalDetailFile from "../../components/Modals/ModalDetailFile";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faRotate, faSpinner } from "@fortawesome/free-solid-svg-icons";
import Alert from "../../components/notification/Alert";
import { Status } from "../../enums/Status";

const columnDefs = [
  { className: "text-center", targets: [2, 4] },
  { orderable: false, targets: [0] },
];

  export type statusAudio = {
    _id: string;
    text: string;
    reference: string;
    url: string;
    status: Status;
  };

  export const defaultStatus = {
    _id: "",
    text: "",
    reference: "",
    url: "",
    status: Status.PENDING,
  };

export default function VisualizarArchivos() {
  const [refresh, setRefresh] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(false);
  const [modalRename, setModalRename] = useState<boolean>(false);
  const [isSpin, setIsSpin] = useState<boolean>(false); // Recargando contenido de carpeta

  const [planeFolders, setPlaneFolders] = useState<Folder[]>([]); // Folders al mismo nivel
  const [allFolders, setAllFolders] = useState<Folder[]>([]); // Folders anidados

  const [currFolder, setCurrFolder] = useState<Folder>(); // Carpeta actual
  const [contentFolder, setContentFolder] = useState<Array<Folder | Archivo>>(
    []
  ); // Contenido de un folder
  const [loadingFolder, setLoadingFolder] = useState<boolean>(false);
  const [loadingRow, setLoadingRow] = useState<string>("");
  const [breadcrumbs, setBreadcrumbs] = useState<string[]>(["Archivos"]);
  const [sideFoldersOpen, setSideFoldersOpen] = useState<any[]>([]); // Carpetas expandidas

  const [selected, setSelected] = useState<any[]>([]); // Carpetas o archivos seleccionado

  const [modalFile, setModalFile] = useState<boolean>(false);
  const [openedFile, setOpenedFile] = useState<any>(); // Archivos seleccionado para abrir
  // Estado del audio
  const [stateAudio, setStateAudio] = useState<statusAudio>(defaultStatus);
  const { state } = useStore();

  useEffect(() => {
    getFolders();
  }, []);

  // Consulta inicial de todos los folders
  async function getFolders() {
    if (!currFolder) setLoading(true);
    const route = `/folders?propietary=${state.user.credentials?._id || ""}`;
    const res = await peticionBack({}, route, "GET", false, toaster);
    if (res) {
      setPlaneFolders(res.data);
     if(res.data.length>0) orderFolders(res.data);
    }
    if (!currFolder) setLoading(false);
  }

  // Anidar folders
  function orderFolders(data: Folder[]) {
    let carpetas = [...data];
    carpetas = sortObjects(carpetas, "name");

    carpetas.forEach((c: Folder) => {
      if (c.folder) {
        const pa = carpetas.find((pf: Folder) => pf._id === c.folder);
        if (pa) {
          if (pa.children === undefined) pa.children = [];
          pa.children.push(c);
        } else delete c.folder;
      }
    });
    const carpetasRaiz = carpetas.filter((f: Folder) => !f.folder);
    setAllFolders(carpetasRaiz);
    if (!currFolder) setCurrFolder(carpetasRaiz[0]);
    setSideFoldersOpen([carpetasRaiz[0]._id]);
    setBreadcrumbs([carpetasRaiz[0].name]);
  }

  useEffect(() => {
    if (currFolder) getContent();
    setSelected([]);
  }, [currFolder]);

  // Consultat contenido de carpeta seleccionada
  async function getContent() {
    setLoadingFolder(true);
    const res = await peticionBack(
      {},
      `/folders/get_content/${currFolder?._id || ""}`,
      "GET",
      false,
      toaster
    );
    if (res) {
      setContentFolder([
        ...res.content.folders.map((f: Folder) => {
          return { ...f, mimetype: "Carpeta" };
        }),
        ...res.content.files.map((a: Archivo) => {
          const sep = a.src.split("/");
          const ixl = sep[sep.length - 1].lastIndexOf(".");
          const clrName = sep[sep.length - 1].substring(0, ixl);
          return { ...a, name: clrName, mimetype: a.mimetype.split("/")[1] };
        }),
      ]);
      setRefresh(true);
    }
    setLoadingFolder(false);
  }

  /* Table */
  const headers = ["", "Nombre", "Fecha de Modificación", "Tipo"];
  const columns = [
    {
      data: null,
      render: (row: any) => (
        <Form.Check.Input
          aria-label={`ck-${row._id}`}
          id={`ck-${row._id}`}
          name={`ck-${row._id}`}
          type="checkbox"
          onChange={() => {}}
          checked={selected.find((el: any) => el._id === row._id)}
          color="danger"
          style={{ width: "20px", height: "20px" }}
          className="m-0"
        />
      ),
    },
    {
      data: null,
      render: (row: any) => (
        <div className="no-select">
          {loadingRow === row._id ? (
            <FontAwesomeIcon
              icon={faSpinner}
              spinPulse
              className="text-info me-1"
              style={{ fontSize: "14px" }}
            />
          ) : (
            <img
              src={"images/" + getType(row.mimetype)}
              alt="typ-file"
              width="16"
              className="me-1"
            />
          )}
          {row.name}
          <span className="ms-3 text-body-tertiary">
            {row.status && row.status !== Status.SUCCESS && `(${row.status})`}
          </span>
        </div>
      ),
      orderValue: "name",
    },
    {
      data: "updatedAt",
      render: (f: string) => <p className="no-select">{f}</p>,
      format: "datetime" as "datetime",
    },
    {
      data: null,
      render: (d: any) => <p className="no-select">{d.mimetype}</p>,
      orderValue: "mimetype",
    },
  ];

  function getType(mimetype: string): string {
    switch (mimetype && mimetype.toUpperCase()) {
      case "PDF":
        return "files/pdf-img.svg";
      case "CARPETA":
        return "folder.svg";
      default:
        return "files/file-unknown.svg";
    }
  }
  // Eliminar carpeta/archivo
  async function deleteRow() {
    const wis = selected[0].mimetype === "Carpeta";
    const endpoint = wis ? "/folders" : "/files";
    setLoading(true);
    const res = await peticionBack(
      {},
      `${endpoint}/${selected[0]._id}`,
      "DELETE",
      true,
      toaster
    );
    if (res) {
      updateFolders(res, -1);
    }
    setLoading(false);
  }
  // Marcar chek de un elemento
  function selectElement(row: any) {
    // const selectedCpy = [...selected];
    // const ix = selected.findIndex((el) => el._id === row._id);
    // if (ix === -1) selectedCpy.push(row);
    // else selectedCpy.splice(ix, 1);
    // setSelected(selectedCpy);
    if (selected.length > 0 && row._id === selected[0]._id) setSelected([]);
    else setSelected([row]);
  }
  // Actualizar las carpetas sin consultar
  function updateFolders(newE: any, exist: number) {
    let ccf = [...contentFolder];
    if (exist === 1) {
      const fe = ccf.find((f: any) => f._id === newE._id);
      if (fe) {
        fe.name = newE.name;
        fe.createdAt = newE.createdAt;
      }
    } else if (exist === 0) {
      ccf.push({
        ...newE,
        mimetype: newE.mimetype?.split("/")[1] || "Carpeta",
      });
    } else if (exist === -1) {
      const idF = ccf.findIndex((f: any) => f._id === newE._id);
      if (idF !== -1) ccf.splice(idF, 1);
    }
    setContentFolder(ccf);
    setRefresh(true);
    getFolders();
  }
  // Seleccionar una carpeta o achivo
  async function openElement(f: any) {
    if (loadingRow) return;
    if (f.mimetype && f.mimetype.toUpperCase() !== "CARPETA") {
      await openFile(f);
    } else {
      openFolder(f);
    }
  }
  // Abrir archivo (fetch file)
  async function openFile(file: Archivo) {
    setLoadingRow(file._id as string);
    peticionBack(
      {},
      `/files/${encodeURIComponent(file._id || "")}`,
      "GET",
      false
    )
      .then((res) => {
        if (!res) throw new Error("No fue posible consultar el documento");
        setOpenedFile({
          pages: res.ocr?.data || [],
          type: res.mimetype.split("/")[1].toUpperCase(),
          src: res.src,
          name: res.ocr?.name || file.name || "Sin nombre",
          id: file._id,
          _id: res._id,
          status: res.status,
          jurisprudence: res.jurisprudence || "",
          folderType: res.folderType || "",
          number: res.number || "",
          year: res.year || "",
          tag: res.tag,
        });
        if (res.tts) {
          setStateAudio(res.tts);
          // if (show) {
          //   if (res?.status === Status.SUCCESS) {
          //     toaster.push(
          //       Alert({
          //         type: "success",
          //         message: "Se ha procesado correctamente",
          //       }),
          //       {
          //         placement: "topEnd",
          //       }
          //     );
          //   } else if (res?.status === Status.PENDING ||
          //     res?.status === Status.STARTED) 
          //   {
          //     showProcessingFile();
          //   }
          // }
        } else {
          setStateAudio({ ...stateAudio, status: Status.NO_PROCESS });
        }
      })
      .catch((err) => {
        toaster.push(Alert({ type: "error", message: err.message }), {
          placement: "topEnd",
        });
        console.error(err);
      })
      .finally(() => setLoadingRow(""));
  }
  // Abrir carpeta
  function openFolder(f: Folder) {
    if (currFolder && currFolder._id === f._id) return;
    let route: string[] = [f.name];
    let currFold: any = { ...f };
    while (currFold && currFold.folder) {
      currFold = findParent(currFold);
      if (currFold) {
        route.unshift(currFold.name);
      }
    }
    setBreadcrumbs(route);
    setCurrFolder(f);
  }
  function findParent(currFold: Folder) {
    return planeFolders.find((fp: Folder) => fp._id === currFold.folder);
  }

  // Abrir modal file al seleccionar file
  useEffect(() => {
    if (openedFile) setModalFile(true);
  }, [openedFile]);

  // Limpiar file al cerrar modal
  useEffect(() => {
    if (!modalFile) setOpenedFile(undefined);
  }, [modalFile]);

  function isPDF() {
    return selected[0].mimetype.toUpperCase() === "PDF";
  }

  async function reloadFolder() {
    if (isSpin) return;
    setIsSpin(true);
    await getContent();
    setIsSpin(false);
  }

  return (
    <>
      <CardC className="" shadow="none">
        <div className="border d-flex flex-row mb-3 py-1 d-none d-md-block">
          <FormName updateFolders={updateFolders} currFolder={currFolder} />
          <UploadFile
            setLoading={setLoading}
            updateFolders={updateFolders}
            currFolder={currFolder}
          />
          <button
            className={"opt-menu " + (selected.length !== 1 && "disabled")}
            type="button"
            disabled={selected.length !== 1}
            onClick={() =>
              swalAction(
                deleteRow,
                "Eliminar",
                `¿Está seguro de eliminar est${
                  selected[0].src ? "e documento" : "a carpeta y su contenido"
                }?`
              )
            }
          >
            <img src="/images/trash.svg" alt="new-folder" width="45" />
            <p className="">Eliminar</p>
          </button>
          <FormName
            selected={selected[0]}
            updateFolders={updateFolders}
            currFolder={currFolder}
            controled={[modalRename, setModalRename]}
          >
            <button
              className={"opt-menu " + (selected.length !== 1 && "disabled")}
              type="button"
              disabled={selected.length !== 1 || isPDF()}
              onClick={() => setModalRename(true)}
            >
              <img src="/images/rename.svg" alt="new-folder" width="45" />
              <p className="">Renombrar</p>
            </button>
          </FormName>
        </div>
        <Row className="position-relative">
          <Col xs={3}>
            <div className="border p-1 d-none d-md-block">
              <Tree
                data={allFolders}
                labelKey="name"
                valueKey="_id"
                renderTreeNode={(node) => (
                  <div>
                    <FolderFillIcon className="text-warning me-1" />
                    {node.name}
                  </div>
                )}
                onSelect={(e) => openElement(e)}
                value={currFolder?._id}
                defaultExpandItemValues={sideFoldersOpen}
                onExpand={(e) => setSideFoldersOpen(e)}
              />
            </div>
          </Col>
          <Col xs={12} md={9}>
            <div className="border h-100 position-relative">
              <div className="border-bottom mb-0 d-flex flex-row justify-content-between">
                <Breadcrumb as="p" className="fs-6 my-1 mx-2">
                  {breadcrumbs.map((b: string) => (
                    <Breadcrumb.Item key={"bc" + b}>{b}</Breadcrumb.Item>
                  ))}
                </Breadcrumb>
                <div className="border-start ">
                  <Whisper
                    placement="top"
                    controlId="tt-reload"
                    trigger="hover"
                    speaker={<Tooltip>Recargar carpeta</Tooltip>}
                  >
                    <FontAwesomeIcon
                      icon={faRotate}
                      className="text-body-tertiary cursor-pointer px-1 pt-1"
                      spin={isSpin}
                      size="2x"
                      onClick={() => reloadFolder()}
                    />
                  </Whisper>
                </div>
              </div>
              <Datatable
                columns={columns}
                headers={headers}
                columnDefs={columnDefs}
                data={contentFolder}
                control="front"
                stateRefresh={[refresh, setRefresh]}
                className="p-0"
                searching={false}
                paging={false}
                info={false}
                eventsRow={{
                  onDoubleClick: (e: any) => openElement(e),
                  onClick: (e: any) => selectElement(e),
                }} //
                order={{ col: 1, opt: "asc" }}
              />
              {loadingFolder && (
                <Loader center backdrop style={{ zIndex: 5 }} />
              )}
            </div>
          </Col>
        </Row>
        <ModalDetailFile
          archivo={openedFile}
          title
          stateShow={[modalFile, setModalFile]}
          hookStateAudio={[stateAudio, setStateAudio]}
        />
      </CardC>
      {loading && <Loader center backdrop style={{ zIndex: 1051 }} />}
    </>
  );
}
